import React from "react";
const UnauthorizedLayout = ({ children }) => (<>{children}</>)

export default UnauthorizedLayout;
